import { jsx as l } from "react/jsx-runtime";
import { c as m } from "./tw-cn-mXgPecoF.mjs";
import { c as e } from "./index-BpNK5r1N.mjs";
const i = ["small", "medium", "large"], p = ["topLeftBottomRight", "topRightBottomLeft"], o = ({
  size: t,
  radius: r,
  device: a
}) => {
  if (r === "topLeftBottomRight")
    switch (t) {
      case "small":
        return a === "mobile" ? "rounded-tl-8 rounded-br-8" : "pc:rounded-tl-8 pc:rounded-br-8";
      case "medium":
        return a === "mobile" ? "rounded-tl-10 rounded-br-10" : "pc:rounded-tl-10 pc:rounded-br-10";
      case "large":
        return a === "mobile" ? "rounded-tl-16 rounded-br-16" : "pc:rounded-tl-16 pc:rounded-br-16";
    }
  switch (t) {
    case "small":
      return a === "mobile" ? "rounded-tr-8 rounded-bl-8" : "pc:rounded-tr-8 pc:rounded-bl-8";
    case "medium":
      return a === "mobile" ? "rounded-tr-10 rounded-bl-10" : "pc:rounded-tr-10 pc:rounded-bl-10";
    case "large":
      return a === "mobile" ? "rounded-tr-16 rounded-bl-16" : "pc:rounded-tr-16 pc:rounded-bl-16";
  }
}, b = e(["inline-flex items-center justify-center align-middle gap-2 py-2"], {
  variants: {
    type: {
      filled_primary: ["bg-fill-primary-main", "text-static-white"],
      filled_secondary: ["bg-fill-primary-weak", "text-text-primary-main"],
      filled_accent: ["bg-fill-accent-main", "text-static-white"],
      filled_accent_secondary: ["bg-fill-accent-weak", "text-text-accent-main"],
      filled_basic: ["bg-fill-neutral-weak1", "text-text-neutral-sub"],
      filled_white: ["bg-static-white", "text-text-neutral-main"],
      filled_blackop: ["bg-opacity-black-60", "text-static-white"],
      filled_whiteop: ["bg-opacity-white-80", "text-text-neutral-main"],
      outlined_primary: ["border border-line-primary-weak1 bg-static-white", "text-text-primary-main"],
      outlined_basic: ["border border-line-neutral-weak2 bg-static-white", "text-text-neutral-sub"],
      outlined_bubble: ["border border-line-primary-weak2", "text-text-primary-main", "bg-fill-primary-weak"]
    },
    size: {
      small: ["min-h-20 px-6 typography-label-10-bold"],
      medium: ["min-h-20 px-6 typography-caption-11-bold"],
      large: ["min-h-26 px-8 typography-body-12-bold"]
    },
    pcSize: {
      small: ["pc:min-h-20 pc:px-6 pc:typography-label-10-bold"],
      medium: ["pc:min-h-20 pc:px-6 pc:typography-caption-11-bold"],
      large: ["pc:min-h-26 pc:px-8 pc:typography-body-12-bold"]
    },
    radius: {
      normal: "rounded-6",
      capsule: "rounded-capsule",
      topLeftBottomRight: "",
      // compoundVariants 에서 처리
      topRightBottomLeft: ""
      // compoundVariants 에서 처리
    }
  },
  compoundVariants: [
    // Mobile
    ...i.flatMap(
      (t) => p.map((r) => ({
        size: t,
        radius: r,
        className: o({ size: t, radius: r, device: "mobile" })
      }))
    ),
    // PC
    ...i.flatMap(
      (t) => p.map((r) => ({
        pcSize: t,
        radius: r,
        className: o({ size: t, radius: r, device: "pc" })
      }))
    )
  ],
  defaultVariants: {
    type: "filled_primary",
    radius: "normal"
  }
}), u = e(
  [
    "inline-flex items-center justify-center align-middle gap-2 z-30",
    "rounded-6 border border-opacity-white-10",
    "bg-opacity-black-80",
    "text-text-membership-weak2"
  ],
  {
    variants: {
      theme: {
        gold: "",
        gold_bubble: "!border-none rounded-4",
        gold_special_price: ""
      },
      size: {
        medium: "min-h-[2.0rem] py-2 px-6 typography-caption-11-bold",
        large: "min-h-[2.6rem] py-2 px-8 typography-body-12-bold"
      },
      pcSize: {
        medium: "pc:min-h-[2.0rem] pc:py-2 pc:px-6 pc:typography-caption-11-bold",
        large: "pc:min-h-[2.6rem] pc:py-2 pc:px-8 pc:typography-body-12-bold"
      }
    },
    defaultVariants: {
      theme: "gold"
    }
  }
), g = e([], {
  variants: {
    size: {
      medium: "size-[1.0rem]",
      large: "size-[1.2rem]"
    },
    pcSize: {
      medium: "pc:size-[1.0rem]",
      large: "pc:size-[1.2rem]"
    }
  }
}), y = e([], {
  variants: {
    size: {
      medium: "w-[2.4rem] h-[1.0rem]",
      large: "w-[2.9rem] h-[1.2rem]"
    },
    pcSize: {
      medium: "pc:w-[2.4rem] pc:h-[1.0rem]",
      large: "pc:w-[2.9rem] pc:h-[1.2rem]"
    }
  }
}), h = e([
  "absolute left-1/2 -ml-4 -bottom-6 pc:bottom-auto pc:rotate-180 pc:top-[-5.5px] pc:clip-path-inset-[0.5px_0_0_0]"
]), x = e(
  [
    "box-border inline-flex items-center justify-center",
    "px-4 rounded-capsule",
    "bg-fill-primary-main text-static-white"
  ],
  {
    variants: {
      size: {
        medium: ["min-w-[1.6rem] min-h-[1.6rem] py-1 typography-label-10-bold"],
        large: ["min-w-[2rem] min-h-[2rem] py-2 typography-body-12-bold"]
      },
      pcSize: {
        medium: ["pc:min-w-[1.6rem] pc:min-h-[1.6rem]  pc:py-1 pc:typography-label-10-bold"],
        large: ["pc:min-w-[2rem] pc:min-h-[2rem]  pc:py-2 pc:typography-body-12-bold"]
      }
    }
  }
), f = e(
  ["inline-flex items-center justify-center py-2", "bg-fill-neutral-weak text-text-neutral-sub"],
  {
    variants: {
      size: {
        medium: ["typography-caption-11-regular px-4 min-h-18 rounded-4 gap-1"],
        large: ["typography-body-12-regular px-8 min-h-26 rounded-6 gap-2"]
      },
      pcSize: {
        medium: ["pc:typography-caption-11-regular pc:px-4 pc:min-h-18 pc:rounded-4 pc:gap-1"],
        large: ["pc:typography-body-12-regular pc:px-8 pc:min-h-26 pc:rounded-6 pc:gap-2"]
      }
    }
  }
), w = e([], {
  variants: {
    size: {
      medium: ["size-12"],
      large: ["size-14"]
    },
    pcSize: {
      medium: ["pc:size-12"],
      large: ["pc:size-14"]
    }
  }
}), z = e([], {
  variants: {
    size: {
      medium: ["w-[0.5rem] h-[1.1rem]"],
      large: ["w-[0.6rem] h-[1.3rem]"]
    },
    pcSize: {
      medium: ["pc:w-[0.5rem] pc:h-[1.1rem]"],
      large: ["pc:w-[0.6rem] pc:h-[1.3rem]"]
    }
  }
}), v = e(
  [
    "inline-flex items-center justify-center rounded-capsule border border-line-primary-weak2 text-text-primary-main bg-fill-primary-weak"
  ],
  {
    variants: {
      size: {
        medium: ["min-h-[1.6rem] px-6 typography-label-8-bold"],
        large: ["min-h-[2.2rem] px-8 typography-body-12-bold"]
      },
      pcSize: {
        medium: ["pc:min-h-[1.6rem] pc:px-6 pc:typography-label-8-bold"],
        large: ["pc:min-h-[2.2rem] pc:px-8 pc:typography-body-12-bold"]
      }
    }
  }
), _ = e(["absolute left-1/2 pointer-events-none"], {
  variants: {
    size: {
      medium: "-bottom-3 -ml-4 h-4 w-8",
      large: "bottom-[-4.1px] -ml-5 h-5 w-10"
    },
    pcSize: {
      medium: "pc:-bottom-3 pc:-ml-4 pc:h-4 pc:w-8",
      large: "pc:bottom-[-4.1px] pc:-ml-5 pc:h-5 pc:w-10"
    }
  }
}), c = e([
  "absolute -top-2 -right-1 size-5 translate-x-full rounded-capsule bg-fill-primary-main"
]), B = ({ className: t, style: r }) => {
  const a = c();
  return /* @__PURE__ */ l("div", { className: m(a, t), style: r });
};
export {
  B as D,
  g as a,
  y as b,
  h as c,
  x as d,
  f as e,
  z as f,
  w as g,
  _ as h,
  v as i,
  u as m,
  b as p
};
